import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalCourseStore from '../../../../stores/global-course-store';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const deleteCourseFeedbackOperation = async (
  programId: number,
  courseId: number,
  feedbackId: number,
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.deleteCourseFeedbackPoll(
      programId,
      courseId,
      feedbackId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      // Refresh course details
      const courseDetails = await appApi.getCourseDetails(programId, courseId);
      globalCourseStore.addCourseDetails(
        courseId,
        courseDetails.data.body.details,
      );

      toast.success('משוב ההוראה נמחק בהצלחה');
    }
    onSuccess();
    setLoading(false);
  } catch (e) {
    toast.error('לא ניתן למחוק את משוב ההוראה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
